import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import TableRowsIcon from '@mui/icons-material/TableRows';

export type EditMode = 'fields' | 'groupings';

interface EditModeToggleProps {
  editMode: EditMode;
  onEditModeChange: (mode: EditMode) => void;
}

const EditModeToggle: React.FC<EditModeToggleProps> = ({
  editMode,
  onEditModeChange,
}) => {
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newMode: EditMode | null,
  ) => {
    if (newMode !== null) {
      onEditModeChange(newMode);
    }
  };

  return (
    <ToggleButtonGroup
      value={editMode}
      exclusive
      onChange={handleChange}
      aria-label="edit mode"
      size="small"
    >
      <ToggleButton value="fields" aria-label="field editing">
        <ViewListIcon />
      </ToggleButton>
      <ToggleButton value="groupings" aria-label="groupings editing">
        <TableRowsIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default EditModeToggle;
